export default __webpack_public_path__ + "static/media/personal-info-edit.8950c06b.svg";